import React, { useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { styled } from "@mui/system";
import { Box, Button, Popover, Toolbar } from "@mui/material";
import { Form, Formik } from "formik";
import InputField from "../../components/formFields/InputField";
import {
  setMemberName,
  setNaicCode,
  setAssessmentClass,
  setIsActive,
  setEmail,
  setGroupName,
  setPaymentOpenStatus,
  setPaymentReceivedDate,
  setInvoiceNumber,
  setMerged,
  setSuspWith,
  setInsolvent,
} from "../../store/slices/FilterSlice";
import { useDispatch, useSelector } from "react-redux";
import SelectField from "../../shared/components/SelectField";
import {
  activityOptions,
  assessmentClasses,
} from "../../pages/tabs/invoicesTab/tableFilter/TableFilter";
import DatePickerField from "../../shared/components/DatePickerField";

const StyledPopover = styled(Popover)({
  "& .MuiPaper-root": {
    padding: "24px",
    height: "fit-content",
    width: "300px",
    flexDirection: "column",
    display: "flex",
    justifyContent: "space-between",
  },
});

const FieldContainer = styled(Box)({
  width: "252px",
  margin: "5px 0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "& .MuiFormLabel-root": {
    marginBottom: "9px",
  },
  "& .MuiInputBase-root": {
    minWidth: "100%",
    minHeight: "30px",
    border: "1px solid #b2b9dc",
    borderRadius: "4px",
    "& input": {
      paddingLeft: "10px",
      paddingRight: "10px",
      paddingBottom: "0px",
      paddingTop: "0px",
    },
  },
});

export const openStatusOptions = [
  {
    id: 1,
    code: "All",
    name: "All",
  },
  {
    id: 2,
    code: "Open",
    name: "Open",
  },
  {
    id: 3,
    code: "Closed",
    name: "Closed",
  },
];

const StyledButton = styled(Button)(({ theme, isfull }) => ({
  backgroundColor: isfull ? theme.palette.primary.main : "",
  color: isfull ? theme.palette.info.contrastText : theme.palette.primary.main,
  svg: {
    color: isfull
      ? theme.palette.info.contrastText
      : theme.palette.primary.main,
  },
}));

export const TableFilter = (props) => {
  const { onApplyFilters, type, assessmentClassesFilter, isActiveFilter, isMemberTab, disableFilterReset } =
    props;
  const { naicCode, memberName, assessmentClass, isActive, email, groupName, paymentOpenStatus, paymentReceivedDate, invoiceNumber, merged, suspWith, insolvent } =
    useSelector((state) => state.filter);

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const onFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    return () => {
      onReset();
    };
  }, []);

  const onReset = (e) => {
    dispatch(setNaicCode(null));
    dispatch(setMemberName(null));
    !isMemberTab && !disableFilterReset && dispatch(setInvoiceNumber(null));

    type === "groups" && dispatch(setEmail(""));
    (type === "groups" || type === "payments") && dispatch(setGroupName(""));
    type === "payments" && dispatch(setPaymentOpenStatus(""));
    type === "payments" && dispatch(setPaymentReceivedDate(null));
  assessmentClassesFilter && dispatch(setAssessmentClass(null));
    isActiveFilter && dispatch(setIsActive(null));
  dispatch(setMerged(null));
  dispatch(setSuspWith(null));
  dispatch(setInsolvent(null));
    setAnchorEl(null);
  onApplyFilters({ naicCode: null, memberName: null, merged: null, suspWith: null, insolvent: null });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSubmit = (value) => {
    // NAIC & Member fields removed; we keep state clearing if they were previously used
    if(value.naicCode !== undefined) dispatch(setNaicCode(value.naicCode));
    if(value.memberName !== undefined) dispatch(setMemberName(value.memberName));
    dispatch(setInvoiceNumber(value.invoiceNumber));

    (type === "roleAssignment" || type === "groups") && dispatch(setEmail(value.email));
   ( type === "groups" || type === "payments") && dispatch(setGroupName(value.groupName));
    type === "payments" && dispatch(setPaymentOpenStatus(value.paymentOpenStatus));
    type === "payments" && dispatch(setPaymentReceivedDate(value.paymentReceivedDate));
    assessmentClassesFilter &&
      dispatch(setAssessmentClass(value.assessmentClass));
  isActiveFilter && dispatch(setIsActive(value.isActive));
  dispatch(setMerged(value.merged));
  dispatch(setSuspWith(value.suspWith));
  dispatch(setInsolvent(value.insolvent));
    onApplyFilters(value);
    setAnchorEl(null);
  };
  return (
    <Toolbar sx={{ minHeight: "0px !important" }}>
      <StyledButton
        onClick={onFilterClick}
        startIcon={<FilterListIcon />}
        variant="outlined"
  isfull={assessmentClass || isActive || email || groupName || paymentOpenStatus || paymentReceivedDate || invoiceNumber || merged || suspWith || insolvent}
      >
        Filter
      </StyledButton>
      <StyledPopover
        id={"filter-popover"}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Formik
          initialValues={{
            naicCode,
            memberName,
            assessmentClass,
            isActive,
            email,
            groupName,
            paymentOpenStatus,
            paymentReceivedDate,
            invoiceNumber,
            merged,
            suspWith,
            insolvent,
          }}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {() => (
            <Form id={"filterForm"}>
              {(type === "groups" || type === "payments") && (
                <FieldContainer>
                  <InputField name={"groupName"} label={"Group Name"} />
                </FieldContainer>
              )}
              {/* Removed NAIC Code & Member Name fields (handled by external unified search) */}
              {assessmentClassesFilter && (
                <FieldContainer>
                  <SelectField
                    name={"assessmentClass"}
                    label={"Assessment Class"}
                    data={assessmentClasses}
                    width="253px"
                  />
                </FieldContainer>
              )}
              {isActiveFilter && (
                <FieldContainer>
                  <SelectField
                    name={"isActive"}
                    label={"Active"}
                    data={activityOptions}
                    width="253px"
                  />
                </FieldContainer>
              )}
              {(type === "members") && (
              <FieldContainer>
                <SelectField
                  name={"merged"}
                  label={"Merged"}
                  data={[{id:1,code:'Yes',name:'Yes'},{id:2,code:'No',name:'No'}]}
                  width="253px"
                />
              </FieldContainer>)}
              {(type === "members") && (
              <FieldContainer>
                <SelectField
                  name={"suspWith"}
                  label={"Susp With"}
                  data={[{id:1,code:'Yes',name:'Yes'},{id:2,code:'No',name:'No'}]}
                  width="253px"
                />
              </FieldContainer>)}
              {(type === "members") && (<FieldContainer>
                <SelectField
                  name={"insolvent"}
                  label={"Insolvent"}
                  data={[{id:1,code:'Yes',name:'Yes'},{id:2,code:'No',name:'No'}]}
                  width="253px"
                />
              </FieldContainer>)}
              {(type === "roleAssignment" || type === "groups") && (
                <FieldContainer>
                  <InputField name={"email"} label={"Email"} />
                </FieldContainer>
              )}
          
              {type === "payments" && (
                <>
                  <FieldContainer>
                    <DatePickerField name={"paymentReceivedDate"} label={"Received date"} width = "100%"/>
                  </FieldContainer>
                  <FieldContainer>
                    <SelectField
                      name={"paymentOpenStatus"}
                      label={"Status"}
                      data={openStatusOptions}
                      width="253px"
                    />
                  </FieldContainer>
                  <FieldContainer>
                    <InputField name={"invoiceNumber"} label={"Invoice Number"} />
                  </FieldContainer>
                </>

              )}
              <Box sx={{ display: "flex" }}>
                <StyledButton type="submit">Apply</StyledButton>
                <StyledButton onClick={onReset}>Reset</StyledButton>
              </Box>
            </Form>
          )}
        </Formik>
      </StyledPopover>
    </Toolbar>
  );
};
